"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var requests = [];
function getRequest(params) {
    var request = requests.find(function (currentRequest) { return currentRequest.hasSameParams(params); });
    return request;
}
function getRequests() {
    // return new array to avoid cache mutation from external modules
    return requests.slice();
}
function addRequest(request) {
    requests.unshift(request);
    request.onAbort = function () { return removeRequest(request); };
    return request;
}
function removeRequest(request) {
    var index = requests.indexOf(request);
    if (index >= 0) {
        requests.splice(index, 1);
    }
}
function removeRequests(url) {
    if (typeof url === 'string') {
        requests = requests.filter(function (request) {
            return request.params.url.indexOf(url) === -1;
        });
    }
    else {
        requests = requests.filter(function (request) {
            return !request.params.url.match(url);
        });
    }
}
function reset() {
    requests = [];
}
exports.default = {
    getRequest: getRequest,
    getRequests: getRequests,
    addRequest: addRequest,
    removeRequests: removeRequests,
    reset: reset,
};
